export default "/images/place.svg?56f316f28586988cd2b59e2352d5c064";